import React, { ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { connectRedux } from '../../../helpers/connectRedux'
import { RouteComponentProps } from '../../../helpers/withRouter'

import { Page } from '../../../components'
import { images } from '../../../images'
import { AuthenticatedRoutable, IClientInfo } from '../../../models'
import literalsService from '../../../services/literals-service'
import { IStoreState } from '../../../store/states'
import StyledArticle from './styles'
import { appsStyleSelected } from '../../../helpers/app'
import { AnyAction } from 'redux'

interface IProps extends IClientInfo, DispatchProp<AnyAction>, RouteComponentProps {}

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps{
  clientInfo: IClientInfo | null
}
class Information extends AuthenticatedRoutable<IProps> {

  private get serviceTelephone(): string | undefined {
    return this.props.clientInfo?.phoneNumber
  }

  private get serviceWeb(): string | undefined {
    return this.props.clientInfo?.url
  }

  private get serviceMail(): string | undefined {
    return this.props.clientInfo?.email
  }

  private get appWeb(): string | undefined {
    return this.props.clientInfo?.appUrl
  }

  private get appMail(): string | undefined {
    return this.props.clientInfo?.appEmail
  }

  private get logos(): ReactNode {
    const { clientInfo } = this.props

    if (clientInfo?.logoUrl) {
      return (
          <section className='images'>
            <img src={clientInfo?.logoUrl} className='logos' />
          </section>
      )
    }

    // hardcoded (old, leaving here for fallback)
    return (
      <section className='images'>
        <img src={ images['logoNemi'] } className='logos' />
      </section>
    )
  }

  public componentDidMount() {
    super.componentDidMount()
  }

  public render(): ReactNode {

    return (
      <Page>
        <Page className={ `authenticated ${appsStyleSelected?.style}` }>
          <StyledArticle>
            <img src={ images['goBack'] } className='backButton' onClick={ this.handleGoBack } />
            <h3>{ literalsService.get('serviceInformation', true) }</h3>
            <section>
              <img src={ images['webPage'] } className='icons' />
              <label className='title'>{ literalsService.get('webPage', true) }</label>
              <label className='link' onClick={ () => this.goToServiceWeb() }>{ this.serviceWeb }</label>
            </section>
            <section>
              <img src={ images['phoneInfo'] } className='icons' />
              <label className='title'>{ literalsService.get('phone', true) }</label>
              <label>{ this.serviceTelephone }</label>
            </section>
            <section>
              <img src={ images['emailInfo'] } className='icons' />
              <label className='title'>{ literalsService.get('email', true) }</label>
              <label className='link' onClick={ () => this.sendServiceMail() }>{ this.serviceMail }</label>
            </section>
            { this.logos }
          </StyledArticle>
        </Page>
      </Page>
    )
  }

  private handleGoBack = (): void => {
    history.back()
  }

  private goToServiceWeb = async (): Promise<void> => {
    const url = this.serviceWeb
    if (!url) return

    window.open(url, '_blank')
  }

  private sendServiceMail = async (): Promise<void> => {
    const url = `mailto:${this.serviceMail}`
    
    window.open(url, '_blank')
  }
}

const mapStateToProps = ({ configuration }: IStoreState) => ({
  clientInfo: configuration.clientInfo
})

export default connectRedux(mapStateToProps, Information)
